"use strict";
function resolveTokenValue(category, value) {
  if (value == null || !Array.isArray(value)) {
    return value;
  }
  switch (category) {
    case "easings":
      return `cubic-bezier(${value.join(", ")})`;
    case "animations":
    case "fonts":
    case "gradients":
    case "shadows":
      return value.join(", ");
    default:
      return value;
  }
}
function resolveSemanticConditionValues(category, conditions) {
  const next = {};
  for (const key in conditions) {
    next[key] = resolveTokenValue(category, conditions[key]);
  }
  return next;
}

export { resolveSemanticConditionValues, resolveTokenValue };
